export function getUnique<T>(sourceArray: T[]): T[] {
  return [...new Set(sourceArray)];
}
